import { SearchField } from "@tokenterminal/core/ui/input/SearchField"
import { useAtom } from "jotai"
import { debounce } from "lodash"
import { useEffect, useMemo, useState } from "react"
import { focusAtom } from "utils/jotai/focusAtom"
import { type FiltersAtomType } from "./ScreenerTable"

export function Search({ filtersAtom }: { filtersAtom: FiltersAtomType }) {
  const [search, setSearch] = useAtom(focusAtom(filtersAtom, "search"))
  const [localSearch, setLocalSearch] = useState(search)
  const debouncedSetSearch = useMemo(
    () => debounce(setSearch, 200),
    [setSearch]
  )

  useEffect(() => {
    if (search === "") {
      setLocalSearch("")
    }
  }, [search])

  const handleChange = (value: string) => {
    setLocalSearch(value)
    debouncedSetSearch(value)
  }

  return (
    <SearchField
      autoFocus
      onChange={handleChange}
      value={localSearch}
      aria-label="Search"
      style={{
        width: "100%",
      }}
    />
  )
}
